import { jsxs as p, Fragment as c, jsx as i } from "react/jsx-runtime";
import { useMemo as m } from "react";
import n from "styled-components";
import x from "../../Icons/ChevronRight.js";
import a from "../../../utils/colors.js";
import { device as t } from "../../../utils/device.js";
const f = n.div`
  @media ${t.isTablet}, ${t.isDesktop} {
    display: none !important;
  }

  @media ${t.isMobile} {
    position: relative;
    transform: translateX(0.5px) translateY(1.5px) rotate(180deg);
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    overflow: hidden;
    width: 9.5px;
    height: 9.5px;
    padding: 0px;
  }
`, h = n.a`
  position: relative;
  background: transparent;
  border: none;
  outline-color: ${a.orange};
  padding: 0;
  padding-top: 1px;
  padding-bottom: 2px;
  padding-left: 7px;
  padding-right: 7px;
  color: ${a.blueGrey};
  font-weight: normal;
  transition: color 0.15s ease-in-out;

  @media ${t.isDesktop}, ${t.isTablet} {
    display: none;
  }

  &:hover,
  &:focus {
    color: ${a.brown};
  }

  .hasLink {
    text-decoration: underline;
    cursor: pointer;
  }
`, l = n.div`
  position: relative;
  margin-left: 11.5px;
  margin-top: 2px;
`, g = n.div`
  position: relative;

  @media ${t.isDesktop}, ${t.isTablet} {
    display: none;
  }
`, L = ({ items: s = [] }) => {
  const r = m(() => s.filter((d) => !!d.link).pop(), [s]);
  let o, e;
  return r ? (o = r.text, e = r.link || "") : (o = "Home", e = "/"), /* @__PURE__ */ p(c, { children: [
    /* @__PURE__ */ i(f, { children: /* @__PURE__ */ i(x, {}) }),
    e ? /* @__PURE__ */ i(
      h,
      {
        className: e ? " hasLink" : "",
        href: e,
        "aria-hidden": e ? "true" : "false",
        tabIndex: e ? void 0 : -1,
        children: /* @__PURE__ */ p(l, { children: [
          "Back to ",
          o
        ] })
      }
    ) : /* @__PURE__ */ i(g, { children: /* @__PURE__ */ i(l, { children: o }) })
  ] });
};
export {
  L as default
};
